// @flow
import React from "react";
import PageContainer from "../containers/PageContainer";
import FourOhFour from "../containers/FourOhFour";
import { useTranslation } from 'react-i18next';

export default function FourOhFourView() {
    const { t } = useTranslation();
  return (
      <PageContainer title={t("Page Not Found")} showShopToolbar={false}>
          <FourOhFour />
    </PageContainer>
  );
}
